import { useQuery } from "react-query";
import { fetchFormConfig } from "../../../api";
import { FormConfig } from "../../../types/form";
import { AxiosError } from "axios";

interface Args {
  accountId: string;
  hash: string;
  isPreview?: boolean;
  passcode?: string | null;
}

interface ReturnType {
  data?: FormConfig;
  isLoading: boolean;
  isFetched: boolean;
  statusCode: number;
}

export const useFetchFormConfig = (args: Args): ReturnType => {
  const { data, status, isLoading, isFetched, error } = useQuery<FormConfig, AxiosError>(
    ["form", args.passcode],
    async () => await fetchFormConfig(args.accountId, args.hash, args.isPreview, args.passcode),
    {
      refetchOnWindowFocus: true,
    }
  );

  const statusCode = defineStatusCode(isLoading, status, error);

  return { data, isLoading, statusCode, isFetched };
};

const defineStatusCode = (
  isLoading: boolean,
  status: string,
  error?: AxiosError | null
): number => {
  if (isLoading) {
    return 0; // Loading state
  }

  if (status === "success") {
    return 200;
  }

  if (error?.status) {
    return error.status;
  }

  throw new Error("Unexpected status code");
};
